import QRCodeStyling from 'qr-code-styling'
import { useEffect, useRef } from 'react'

import { useTheme } from '../../hooks/useTheme'

interface IProps {
  data?: string
  bgColor?: string
  fgColor?: string
  logo?: string
}

export const QRCodeGenerator: React.FC<IProps> = ({ data, bgColor, fgColor, logo }) => {
  const { resolvedTheme } = useTheme()
  const containerRef = useRef<HTMLDivElement | null>(null)
  const qrRef = useRef<QRCodeStyling | null>(null)

  // Create once
  useEffect(() => {
    if (!containerRef.current || qrRef.current) return

    qrRef.current = new QRCodeStyling({
      width: 300,
      height: 300,
      image: logo || resolvedTheme.logoSecondary || resolvedTheme.logoPrimary || '/assets/logos/logo_r_dark_qr_code.png',
      backgroundOptions: {
        color: bgColor || resolvedTheme.bg
      },
      dotsOptions: {
        color: fgColor || resolvedTheme.text
        // type: 'extra-rounded'
      },
      cornersSquareOptions: {
        // type: 'extra-rounded'
      },
      imageOptions: {
        crossOrigin: 'anonymous',
        imageSize: 0.25,
        margin: logo ? 3 : 10
      }
    })

    qrRef.current.append(containerRef.current)
  }, [resolvedTheme, logo, bgColor, fgColor])

  // Update when data/colors/logo/theme changes
  useEffect(() => {
    if (!qrRef.current) return

    qrRef.current.update({
      data: data || '',
      image: logo || resolvedTheme.logoSecondary || resolvedTheme.logoPrimary || '/assets/logos/logo_r_dark_qr_code.png',
      backgroundOptions: { color: bgColor || resolvedTheme.bg },
      dotsOptions: { color: fgColor || resolvedTheme.text, type: 'dots' }
    })
  }, [data, bgColor, fgColor, logo, resolvedTheme])

  return (
    <div
      ref={containerRef}
      style={{
        backgroundColor: bgColor || resolvedTheme.bg
      }}
    />
  )
}
